import { css } from 'styled-components';
import { theme, toRem } from 'design';

const InputStyles = css<{ hasError?: boolean }>`
  position: relative;
  width: 100%;
  height: ${toRem(theme.input.height.large)};
  padding: 0 ${toRem(11)};
  border-radius: ${toRem(5.5)};
  border: ${toRem(1)} solid ${theme.color.neutral[200]};
  outline: none;
  background-color: ${theme.color.white};
  font-family: ${theme.font.family.euclid};
  font-weight: ${theme.font.weight.regular};
  font-size: ${toRem(13.25)};
  line-height: 100%;
  color: ${theme.color.neutral[900]};

  &::placeholder {
    color: ${theme.color.neutral[400]};
  }

  &:hover {
    border-color: ${theme.color.neutral[400]};
    background-color: ${theme.color.white};
  }

  &:focus {
    border-color: ${theme.color.neutral[400]};
  }

  ${({ hasError }) =>
    hasError &&
    css`
      border-color: ${theme.color.danger.medium} !important;
    `}

  &:disabled {
    border-color: ${theme.color.neutral[100]};
    background-color: ${theme.color.neutral[100]};
    color: ${theme.color.neutral[700]};
    padding: 0 ${toRem(11)} !important;
    border: ${toRem(1)} solid ${theme.color.neutral[200]} !important;

    &:hover,
    &:focus {
      border-color: ${theme.color.neutral[100]};
      background-color: ${theme.color.neutral[100]};
    }

    &::placeholder {
      color: ${theme.color.neutral[400]};
    }
  }

  &:read-only&:not(:disabled) {
    padding: 0;
    border: none;
    background-color: transparent;
    opacity: 1;
    color: ${theme.color.neutral[900]};

    &:hover,
    &:focus {
      background-color: transparent;
      color: ${theme.color.neutral[900]};
    }
  }
`;

export default InputStyles;
